<i18n src="../../locales/lang.json"></i18n>

  <template>
    <div class="container-fluid p-0 m-0">
      <div class="row p-0 m-0">
        <div class="col-12 p-0 m-0">
          <div class="cal" v-bind:id="'calender' + getId()"></div>
        </div>
      </div>
      <div class="row p-0 m-0">
        <div class="col-12 p-0 m-0 pb-2">
          <table style="width:100%">
            <tr><td><span class="h3">{{$t('important_dates')}}</span></td></tr>
            <tr style="background-color:white;" v-for="d in hollidays"><td class="pl-3"><a style="color:initial" href="#" @click="showDetailedView(d)">{{d.Summary}}</a></td><td>{{d.StartDateString}} {{$t('to')}} {{d.EndDateString}}</td></tr>
            <tr style="background-color:white;" v-for="d in importantDates"><td class="pl-3"><a style="color:initial" href="#" @click="showDetailedView(d)">{{d.Summary}}</a></td><td>{{d.StartDateString}} {{$t('to')}} {{d.EndDateString}}</td></tr>
          </table>
        </div>
      </div>
      <modal-in-front v-bind:title="Details" ref="thisModal" size="modal-md">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12"><h1>{{detail_summary}} {{detail_startDateString}} {{$t('to')}} {{detail_endDateString}}</h1></div>
            </div>
            <div class="row">
              <div class="col-12">{{detail_description}}</div>
            </div>
          </div>
      </modal-in-front>
    </div>
  </template>

<script>

  var currentDate = new Date();
  var currentMonth = "initial";
  var currentYear = "initial";
  var onChangeHandler = null;


  import moment from 'moment'

	export default {
    name: 'input-inline-calender-and-dates',
		components: {
    },
    props: {

    },
    methods: {
      showDetailedView(d) {
        this.$emit('show_detail', d);
        this.$root.$emit('calender_show_detail', d);
        this.detail_summary = d.Summary;
        this.detail_startDateString = d.StartDateString;
        this.detail_endDateString = d.EndDateString;
        this.detail_description = d.Description;
        this.$refs.thisModal.open();
      },
      changedDate() {

        var selectedDate = $('#calender' + this.getId()).datepicker('getDate');
        var mom = new moment(selectedDate);
        this.$emit('changed_date', selectedDate);
      },
      getId() {
        return this._uid;
      },
      prevDate() {
        this.step(-1);
      },
      nextDate() {
        this.step(1);
      },
      step(months) {
        
        var mom = new moment(this.currentDate);
        if (months < 0) {
          this.currentDate = mom.add(months, "month");
          mom = new moment(this.currentDate)
        }
        else if (months > 0) {
          this.currentDate = mom.add(months, "month");
          mom = new moment(this.currentDate)
        }
        this.currentMonth = mom.format('MMMM');
        this.currentYear = mom.format('YY');
        
        if (this.onChangeHandler != null) {
          this.onChangeHandler(mom.format('YY'), mom.format('MM'));
        }
          
      },
      onChange(handler) {
        this.onChangeHandler = handler;
      },
      setHighlightDates(date, highlightDates) {
        this.highligteddates = highlightDates;
        this.initCalender(date);
        this.$forceUpdate();
      },
      setHollidayDates(date, hollidayDates) {
        this.hollidays = hollidayDates;
        this.initCalender(date);
        this.$forceUpdate();
      },
      setImportantDates(date, importantDates) {
        this.importantDates = importantDates;
        this.$forceUpdate();
      },
      initCalender(date) {

        var thisContext = this;
        var tmpLoc = $.datepicker.regional[this.$store.getLocale()];

        tmpLoc["beforeShowDay"] = function (date) {
          var m = moment(date);
          var mFormatted = m.format('YYYY-MM-DD');
          
          for (var i = 0; i < thisContext.highligteddates.length; i++) {
            var m2 = moment(thisContext.highligteddates[i].StartDateString);
            if (mFormatted == m2.format('YYYY-MM-DD'))
              return [true, 'custom-highlight', 'Info..'];
          }
          for (var i = 0; i < thisContext.hollidays.length; i++) {
            var m2 = moment(thisContext.hollidays[i].StartDateString);
            if (mFormatted == m2.format('YYYY-MM-DD'))
              return [true, 'custom-holliday-highlight', 'Info..'];
          }

          for (var i = 0; i < thisContext.importantDates.length; i++) {
            var m2 = moment(thisContext.importantDates[i].StartDateString);
            if (mFormatted == m2.format('YYYY-MM-DD'))
              return [true, 'custom-important-highlight', 'Info..'];
          }
          return [true, '']
        }

        tmpLoc["onChangeMonthYear"] = function (year, month, inst) {
          thisContext.$emit('changed_month', new Date(year, month - 1, 1));
        }
        
        $('#calender' + this.getId()).datepicker(tmpLoc);

        $('#calender' + this.getId()).datepicker("refresh");

        $('#calender' + this.getId()).change(this.changedDate);

        
      }
      
    },
    data() {
      return {
        currentDate,
        currentMonth,
        currentYear,
        onChangeHandler,
        highligteddates: [],
        hollidays: [],
        importantDates: [],
        detail_summary : '',
        detail_startDateString: '',
        detail_endDateString: '',
        detail_description: '',
      }
    },
    created() {
      
    },
    mounted() {
      this.step(0);
      this.initCalender(new Date());
    },
    computed: {
      
    },
    watch: {
      
    }
}
</script>

<style>
  .cal .ui-datepicker {
    padding: 0px !important;
    width: 100%;
    font-size: 10px;
    min-width:initial;
  }
  .cal .ui-datepicker-calendar td a{
      min-width:initial;
  }

  .cal td.custom-highlight {
    border: none !important;
    padding: 1px 0 1px 1px !important;
    background: none !important;
    overflow: hidden;
  }

  /*
    .cal td.custom-highlight a {
      background-color: #BAD1AA !important;
      border: 1px #88a276 solid !important;
    }

  */
</style>



// WEBPACK FOOTER //
// src/components/form-components/input-inline-calender-and-dates.vue